module.exports = __webpack_public_path__ + "static/media/Description_to_download_the_GPX_file_RO_RO_LAT.377d887e.pdf";